/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

import dateFormat from '@/tools/dateFormat';
import { projectSettled } from '@/api/ajax';
import { auditStatusMapping } from './mapping';
import store from '@/store';
import {
  createQualificationDetail,
  passQualifications,
  rejectQualifications
} from '../components/qualification-detail';
const exitPass = function(row, auditStatus) {
  this.$confirm('审核后将无法修改，确定要提交吗?', '', {
    showCancelButton: true,
    showConfirmButton: true
  }).then(() => {
    projectSettled
      .auditSettledOut({
        id: row.id,
        auditStatus,
        userId: row.userId
      })
      .then(() => {
        this.$message({
          title: '成功',
          message: '操作成功',
          type: 'success'
        });
        this.saveSuccess();
      });
  });
};
const applyPass = function(row, auditStatus) {
  this.$confirm('审核后将无法修改，确定要提交吗?', '', {
    showCancelButton: true,
    showConfirmButton: true
  }).then(() => {
    const ajax =
      auditStatus === 2
        ? projectSettled.applicationIn
        : projectSettled.userEnterProjectCheckNo;
    ajax({
      id: row.id,
      auditStatus,
      userId: row.userId,
      checkStatus: 3,
      projectId: store.state.homeProject.id
    }).then(() => {
      this.$message({
        title: '成功',
        message: '操作成功',
        type: 'success'
      });
      this.saveSuccess();
    });
  });
};
const toRecord = function(row) {
  this.$router.push({
    name: 'record',
    query: {
      activeTask: 'recordList',
      id: this.$route.query.id,
      userName: row.userName,
      userIdParam: row.userId
    }
  });
};

const userIsDisabled = row => {
  return (
    row.zbBlackStatus == 2 || row.userStatus == 3 || row.superviseStatus == 3
  );
};
const certificationCanAudit = row => {
  if ([null, void 0].includes(row.cpuId)) return false;
  if (userIsDisabled(row)) {
    return false;
  }
  if (
    [2, 3].includes(row.auditAspStatus) ||
    [2, 3].includes(row.auditOssStatus)
  ) {
    return false;
  }
  return true;
};
const certificationAuditStatus = row => {
  if ([null, void 0].includes(row.cpuId)) return '-';
  if (row.zbBlackStatus == 2 || row.superviseStatus == 3) {
    return '-';
  }
  if (row.auditOssStatus == 3) {
    return '审核未通过';
  }
  return (
    { 1: '待审核', 2: '审核通过', 3: '审核未通过' }[row.auditAspStatus] || '-'
  );
};
export default {
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  //   <template slot-scope="{ row }">
  //   <div
  //     style="display:flex;justify-content:space-around;align-items:center;"
  //   >
  //     <el-button type="text" @click="goDia(row, 'jingying')">
  //       {{ row.userName }}
  //     </el-button>
  //   </div>
  // </template>
  userName: {
    label: '项目参与人',
    prop: 'userName'
  },
  //   <template slot-scope="{ row }">
  //   <div
  //     style="display:flex;justify-content:space-around;align-items:center;"
  //   >
  //     <el-button type="text" @click="goDia(row, 'geti')">
  //       {{ row.zooidEnterpriseName || '无' }}
  //     </el-button>
  //   </div>
  // </template>
  zooidEnterpriseName: {
    label: '个体',
    prop: 'zooidEnterpriseName'
  },
  phone: {
    label: '手机号',
    prop: 'phone'
  },
  settledInDt: {
    label: '入驻时间',
    prop: 'settledInDt',
    formatter(row, ctx, v) {
      return dateFormat(v) || '-';
    }
  },
  status: {
    label: '入驻状态',
    prop: 'status',
    formatter(row, ctx, v) {
      return !v ? '未入驻' : '已入驻';
    }
  },
  createDt: {
    label: '申请退出时间',
    prop: 'createDt',
    formatter(row, ctx, v) {
      return dateFormat(v) || '-';
    }
  },
  toReCord: {
    label: '任务记录',
    render(h, ctx, row) {
      const parent = ctx.parent;

      return (
        <div>
          <el-button
            type="text"
            size="small"
            onClick={toRecord.bind(parent, row)}
          >
            详情
          </el-button>
        </div>
      );
    }
  },
  auditStatus: {
    label: '状态',
    prop: 'auditStatus',
    formatter(row, ctx, v) {
      return auditStatusMapping[v] || '-';
    }
  },
  checkStatus: {
    label: '审核状态',
    prop: 'checkStatus',
    formatter(row, ctx, v) {
      return auditStatusMapping[v] || '-';
    }
  },
  exitHandler: {
    label: '操作',
    render(h, ctx, row) {
      const parent = ctx.parent;
      const disabled = [2, 3].includes(row.auditStatus);
      return (
        <div>
          <el-button
            type="text"
            size="small"
            disabled={disabled}
            onClick={exitPass.bind(parent, row, 2)}
          >
            通过
          </el-button>
          <el-button
            type="text"
            size="small"
            disabled={disabled}
            onClick={exitPass.bind(parent, row, 3)}
          >
            不通过
          </el-button>
        </div>
      );
    }
  },
  applyHandler: {
    label: '操作',
    prop: 'applyHandler',
    render(h, ctx, row) {
      const parent = ctx.parent;
      // FIXME: 暂时使用。申请名单去掉多选并禁用审核。[2, 3].includes(row.auditStatus)
      const disabled = true; // [2, 3].includes(row.checkStatus);
      return (
        <div>
          <el-button
            type="text"
            size="small"
            disabled={disabled}
            onClick={applyPass.bind(parent, row, 2)}
          >
            通过
          </el-button>
          <el-button
            type="text"
            size="small"
            disabled={disabled}
            onClick={applyPass.bind(parent, row, 3)}
          >
            不通过
          </el-button>
        </div>
      );
    }
  },
  selection: {
    type: 'selection',
    width: '50px',
    prop: 'selection',
    reserve: true,
    selectable: row => {
      return certificationCanAudit(row);
    }
  },
  certificationUpload: {
    label: '资质证明',
    prop: 'certificationUpload',
    formatter(row) {
      return row['cpuId'] > 0 ? '已上传' : '未上传';
    }
  },
  auditOssStatus: {
    label: '审核状态',
    prop: 'auditOssStatus',
    render(h, ctx, row) {
      return (
        <div>
          <span>{certificationAuditStatus(row)}</span>
          {!userIsDisabled(row) &&
            row['auditOpinion'] &&
            (row['auditAspStatus'] === 3 || row['auditOssStatus'] === 3) && (
              <el-tooltip
                class="item"
                effect="dark"
                content={`${row.auditOssStatus === 3 ? '【平台】' : ''}${
                  row.auditOpinion
                }`}
                placement="top-start"
              >
                <i
                  style={{ fontSize: '15px', marginLeft: '10px' }}
                  class="el-icon-question"
                ></i>
              </el-tooltip>
            )}
        </div>
      );
    }
  },
  importOperation: {
    label: '操作',
    prop: 'importOperation',
    width: 160,
    render(h, ctx, row) {
      const projectId = store.state.homeProject.id;
      let type = 1;
      try {
        type = ctx.parent.defaultQuery._qualificationAuditParams.type;
      } catch (error) {
        console.warn(
          'get defaultQuery _qualificationAuditParams type fail',
          error
        );
      }
      return (
        <div>
          <el-button
            type="text"
            size="small"
            disabled={[null, void 0].includes(row.cpuId) || userIsDisabled(row)}
            onClick={() => {
              createQualificationDetail({
                id: row.cpuId,
                defaultParams: {
                  isNextData: 1,
                  projectId,
                  type
                }
              }).then(res => {
                if (res && res.size > 0) {
                  ctx.parent.reGetPage();
                }
              });
            }}
          >
            查看
          </el-button>
          <el-button
            type="text"
            size="small"
            disabled={!certificationCanAudit(row)}
            onClick={async () => {
              await passQualifications([row.userId], {
                projectId,
                type
              });
              ctx.parent.reGetPage();
            }}
          >
            通过
          </el-button>
          <el-button
            type="text"
            size="small"
            disabled={!certificationCanAudit(row)}
            onClick={async () => {
              await rejectQualifications(
                [row.userId],
                {
                  projectId,
                  type
                },
                { min: type == 2 ? 0 : 5, max: 150 }
              );
              ctx.parent.reGetPage();
            }}
          >
            不通过
          </el-button>
        </div>
      );
    }
  }
};
